import ConvenioUpdate from './ConvenioUpdate'
export {ConvenioUpdate}
export default ConvenioUpdate
